import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { PaymentContext } from "./data/context";
import { authContext } from "./data/authContext";
import { ContextProvider } from "./context";
import { homePageService } from "./jwt/_services/home-page-service";
import "./assets/css/style.css";
import AuthenticateUser from "./aws-pool/authenticate-user";
import Header from "./section/header/header";
import Footer from "./section/footer/footer";
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import {
  EMAIL_AWS_COGNITO,
  PASSWORD_AWS_COGNITO,
  USER_NAME_AWS_COGNITO,
  getSecret,
} from "../src/common";
import authAwsPool from "../src/aws-pool/auth-aws";
import ConnectionError from "./views/error-pages/connection-error";
// import NGS from "../src/views/national-gallary-singapor"
import { history } from "./jwt/_helpers";
import Loader from "./views/national-gallary-singapor/loader";
import dummyData from "./views/national-gallary-singapor/dummy.json";
import { config, paths } from "./common/constant";
import pageConnectionError from "./views/error-pages/page-connection-error";

const NGS = lazy(() => import("./views/national-gallary-singapor"));
const PaymentToCause = lazy(() => import("./views/payments/cause"));
const PaymentToCampaign = lazy(() => import("./views/payments/campaign"));
const PaymentToAdoptArtwork = lazy(() =>
  import("./views/payments/adopt-artwork")
);
const PaymentToPatron = lazy(() => import("./views/payments/patron"));
const CampaignDetails = lazy(() => import("./views/details-campaign"));
const ArtWorkDetails = lazy(() => import("./views/details-artwork"));
const PatronProgrammeDetaiils = lazy(() =>
  import("./views/details-patron-programme")
);
const AllCharitiesCampaigns = lazy(() =>
  import("./views/all-charities-campaigns/see-all-charities-campaigns")
);
const AllAdoptArtWork = lazy(() => import("./views/all-artworks"));
const AllDonorsWall = lazy(() => import("./views/all-donors-wall"));
const UserProfile = lazy(() => import("./views/profile"));
const ReceiptDonation = lazy(() => import("./views/receipts/receipt"));
const RegistrationForTaxDeduction = lazy(() =>
  import("./views/register/tax-deduction")
);
const EnrollIndividual = lazy(() =>
  import("./views/payments/components/enroll-individual")
);
const SingpassUpdate = lazy(() =>
  import("./views/payments/components/signpass-update")
);
const SingpassLogin = lazy(() =>
  import("./views/payments/components/singpass-login")
);
const Enrollment = lazy(() => import("./views/payments/campaign/index"));
// const Enrollment = lazy(() => import('./views/payments/charity/enrollment'));
//const AllPatronProgrammes = lazy(() => import('./views/all-patron-programmes'));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: window.location.host,
      isDataLoaded: false,
      settingsData: [],
      isOnline: window.navigator.onLine,
      isAuthorised: false,
    };

    // setTimeout(() => { AuthenticateUser() }, 2000)
    this.getHomePageData = this.getHomePageData.bind(this);
    this.getAuthorisedHomePage = this.getAuthorisedHomePage.bind(this);
    this.updateConnection = this.updateConnection.bind(this);
  }

  getHomePageData() {
    let response = dummyData;
    // homePageService.getHomePageSettings()
    //   .then(response => {
    if (response) {
      response.PaymentContext = PaymentContext;
      this.setState({
        settingsData: response ?? [],
        isDataLoaded: true,
      });
    } else {
      this.setState({
        isOnline: false,
        isDataLoading: true,
        settingsData: [],
      });
    }
    //});
  }

  //isLoadHomePage allow to load homepage data boolian flag
  // getAuthorisedHomePage(isLoadHomePage) {
  //   const user = new CognitoUser({
  //     Username: USER_NAME_AWS_COGNITO,
  //     Pool: authAwsPool,
  //   });

  //   const authDetails = new AuthenticationDetails({
  //     Username: USER_NAME_AWS_COGNITO,
  //     Password: PASSWORD_AWS_COGNITO,
  //   });

  //   user.authenticateUser(authDetails, {
  //     onSuccess: (data) => {
  //       authContext.AccessToken = data.accessToken.jwtToken
  //       authContext.IdToken = data.idToken.jwtToken
  //       authContext.RefreshToken = data.refreshToken.token
  //       if (isLoadHomePage) {
  //         this.getHomePageData();
  //       } else {
  //         this.setState({
  //           isDataLoaded: true
  //         })
  //       }
  //       this.setState({
  //         isAuthorised: true
  //       })
  //     },
  //     onFailure: (error) => {
  //       console.error("onFailure: ", error);
  //     },
  //     newPasswordRequired: (response) => {
  //       const userAttributes = {
  //         'email': EMAIL_AWS_COGNITO
  //       }
  //       console.log("newPasswordRequired: ", userAttributes, response);
  //       user.completeNewPasswordChallenge(PASSWORD_AWS_COGNITO, userAttributes, {
  //         onSuccess: (result) => {
  //           console.log("NEW PASSWORD COMPLETED: New Password Set");
  //         },
  //         onFailure: (err) => {
  //         }
  //       })
  //     },
  //   })
  // }

  async getAuthorizerDetails() {
    let poolId = await getSecret(
      `/${config.TYPE.toLowerCase()}${paths.AuthorizerAccessKey}`
    );
    let clientId = await getSecret(
      `/${config.TYPE.toLowerCase()}${paths.AuthorizerClientId}`
    );

    return {
      UserPoolId: poolId,
      ClientId: clientId,
    };
  }

  getAuthorisedHomePage(isLoadHomePage, poolDetails) {
    const user = new CognitoUser({
      Username: USER_NAME_AWS_COGNITO,
      Pool: new CognitoUserPool(poolDetails),
    });

    const authDetails = new AuthenticationDetails({
      Username: USER_NAME_AWS_COGNITO,
      Password: PASSWORD_AWS_COGNITO,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        // localStorage.setItem("accessToken", data.)AccessToken, IdToken, RefreshToken, TokenType=Bearer
        authContext.AccessToken = data.accessToken.jwtToken;
        authContext.IdToken = data.idToken.jwtToken;
        authContext.RefreshToken = data.refreshToken.token;
        // authContext.TokenType = data.refreshToken.token
        if (isLoadHomePage) {
          this.getHomePageData();
          // this.token();
        } else {
          this.setState({
            isDataLoaded: true,
          });
        }
        this.setState({
          isAuthorised: true,
        });
      },
      onFailure: (error) => {
        console.error("onFailure: ", error);
      },
      newPasswordRequired: (response) => {
        const userAttributes = {
          email: EMAIL_AWS_COGNITO,
        };
        console.log("newPasswordRequired: ", userAttributes, response);
        user.completeNewPasswordChallenge(
          PASSWORD_AWS_COGNITO,
          userAttributes,
          {
            onSuccess: (result) => {
              console.log("NEW PASSWORD COMPLETED: New Password Set");
              // console.log(result);
            },
            onFailure: (err) => {
              // console.log(err);
            },
          }
        );
      },
    });
  }

  updateConnection(status) {
    this.setState({
      isOnline: status,
    });
  }

  componentDidMount() {
    this.getAuthorizerDetails().then((poolDetails) => {
      if (
        window.location.pathname.indexOf("/receipt") !== -1 ||
        window.location.pathname.indexOf("/register") !== -1
      ) {
        this.getAuthorisedHomePage(false, poolDetails);
      } else {
        this.getAuthorisedHomePage(true, poolDetails);
      }

      window.addEventListener("offline", () => this.updateConnection(false));
      window.addEventListener("online", () => this.updateConnection(true));
    });
  }

  render() {
    const pageErrorData = {
      title: ' 404',
      subtitle: 'The content you requested cannot be displayed right now. It might be temporarily unavailable or the link you clicked on may have expired.',
      linkURL: `/`
    }
    return (
      <>
        {this.state.isOnline ? (
          <>
            {this.state.isDataLoaded && this.state.isAuthorised ? (
              window.location.pathname.indexOf("/receipt") !== -1 ||
                window.location.pathname.indexOf("/register") !== -1 ? (
                <BrowserRouter>
                  <Suspense fallback={<Loader />}>
                    <Switch>
                      <Route
                        exact
                        path="/receipt/donation"
                        component={ReceiptDonation}
                      />
                      <Route
                        exact
                        path="/receipt/adoption"
                        component={ReceiptDonation}
                      />
                      {/* <Route path="/register/tax-deduction" component={RegistrationForTaxDeduction} /> */}
                    </Switch>
                  </Suspense>
                </BrowserRouter>
              ) : (
                <ContextProvider value={this.state.settingsData}>
                  {
                    <BrowserRouter>
                      {/* <Header /> */}
                      {this.state.isOnline ? (
                        <Suspense fallback={<Loader />}>
                          <Switch>
                            {/* <Route path="*" component={ConnectionError} /> */}
                            {/* <Route exact path="/payments" component={PaymentToCause} />
                              <Route exact path="/mosque/payment" component={PaymentToCampaign} />
                              <Route exact path="/adoptnow/payment" component={PaymentToAdoptArtwork} />
                              <Route exact path="/patrons/payment" component={PaymentToPatron} />
                              <Route exact path="/mosque/:mosqueId" component={CampaignDetails} />
                              <Route exact path="/adoptnow/:artworkId" component={ArtWorkDetails} />
                              <Route exact path="/patrons" component={PatronProgrammeDetaiils} />
                              <Route exact path="/all/mosques" component={AllCharitiesCampaigns} />
                              <Route exact path="/all/adoptnow" component={AllAdoptArtWork} />
                              <Route exact path="/all/patrons" component={PatronProgrammeDetaiils} /> 
                              <Route exact path="/all/donors-wall" component={AllDonorsWall} />
                              <Route exact path="/profile" component={UserProfile} /> 
                              <Route exact path="/aws-pool" component={AuthenticateUser} />
                              <Route exact path="/signpass/confirmation" component={AuthenticateUser} />
                              <Route exact path="/enrollment/enroll-individual" component={EnrollIndividual} />
                              <Route exact path="/enrollment/singpass-update" component={SingpassUpdate} />
                              <Route exact path="/enrollment/singpass" component={SingpassLogin} />
                              <Route exact path="/enrollment" component={Enrollment} /> */}
                            {/* <Route path="/" component={NGS} /> */}
                            <Route exact path="*" component={pageConnectionError} />
                          </Switch>
                        </Suspense>
                      ) : (
                        <ConnectionError></ConnectionError>
                      )}
                      {/* <Footer /> */}
                    </BrowserRouter>
                  }
                </ContextProvider>
              )
            ) : (
              <Loader />
            )}
          </>
        ) : (
          <ConnectionError></ConnectionError>
        )}
      </>
    );
  }
}

export default App;
